<div class="content">
    <h2 class="mat-h2">{{ 'default.loadingApp' | blah }}</h2>
</div>